module.exports = __webpack_public_path__ + "static/media/large-yellow card.03398fac.png";